import { BACKEND_URL } from '@/core/config';
import { RateModel } from '@/interface';
import { server } from '../core/server/axios';

export interface UpdateRateManyVariables {
	depId: string | number;
	id: string | number;
	buy: string;
	sale: string;
	limitFrom: number;
	limitTo: number;
	initiator: string;
}
/** Новая запись курса валюты отделения */
export interface AddRateVariables {
	currencyId: number;
	buy: number;
	sale: number;
	limitFrom: number;
	limitTo: number;
	initiator: string;
}

export interface WacModel {
	currencyId: number;
	currentWac: number;
	lastKaseRate: number;
	revaluationKzt: number;
	updatedAt: string;
	depId: number;
}

export class RateController {
	async updateRateMany(rates: UpdateRateManyVariables[]) {
		return await server.patch('/Rates/updateRateMany', rates, {
			baseURL: BACKEND_URL
		});
	}

	/**
	 * Заводит запись курса у валюты, у которой её нет: без неё курс не
	 * отредактировать, updateRateMany правит курс по rateId. Тело — один объект,
	 * не массив. Отказ бэк отдаёт со статусом 200: строкой (нарушен спред) или
	 * объектом исключения, поэтому успех — только ответ с rateId. После
	 * добавления бэк сам рассылает отделения по сокету ReceiveRates.
	 */
	async addRate(rate: AddRateVariables): Promise<RateModel | string | { message?: string }> {
		return await server.post('/Rates/addRate', rate, {
			baseURL: BACKEND_URL
		});
	}

	async getAverageRate(depId: string | number, curCode: string, days: number) {
		return await server.get(`/Rates/getAvgRate/${depId}/${curCode}/${days}`, {
			baseURL: BACKEND_URL
		});
	}

	async getAverageRateFifo(depId: string | number, curId: string | number) {
		return await server.get(`/Rates/getAvgRateFifo/${depId}/${curId}`, {
			baseURL: BACKEND_URL
		});
	}

	async getAverageRateWac(kassaId: string | number, curId: string | number) {
		return await server.get(`/Wac/current?kassaId=${kassaId}&currencyId=${curId}`, {
			baseURL: BACKEND_URL
		});
	}

	async getWacDocument({ depId, from, to }: { depId: string | number, from?: any; to?: any; }): Promise<any> {
		return await server.get(`Summary/finresult-export?depId=${depId}&fromDate=${from}&toDate=${to}`, {
			responseType: "blob",
			baseURL: BACKEND_URL
		});
	}

	async getAllWac(): Promise<WacModel[]> {
		return await server.get("Wac/revaluation", {
			baseURL: BACKEND_URL
		});
	}

	async getSummaryDocument({ depId, from, to }: { depId: string | number, from?: any; to?: any; }): Promise<any> {
		return await server.get(`Summary/daily-export?depId=${depId}&fromDate=${from}&toDate=${to}`, {
			responseType: "blob",
			baseURL: BACKEND_URL
		});
	}

	async getDailyReportDocument({ depId, from, to }: { depId: (string | number)[], from?: any; to?: any; }): Promise<any> {
		return await server.post(`Summary/daily-cashier-report-export`,
			{
				fromDate: from + "T00:00:00.000Z",
				toDate: to + "T23:59:59.999Z",
				depId

			},
			{
				responseType: "blob",
				baseURL: BACKEND_URL
			});
	}
}